import styled from 'styled-components'
import Theme from 'theme'

export const StyledSpecificationsOptionsReport = styled.div`
  .tableStyle {
    display: table;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    -webkit-letter-spacing: 1px;
    -moz-letter-spacing: 1px;
    -ms-letter-spacing: 1px;
    letter-spacing: 1px;
    box-sizing: border-box;
    table-layout: fixed;
    width: 100%;
    border-spacing: unset;
  }

  .tableRow {
    display: table-row;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    -webkit-letter-spacing: 1px;
    -moz-letter-spacing: 1px;
    -ms-letter-spacing: 1px;
    letter-spacing: 1px;
    box-sizing: border-box;
  }

  .tableRow:nth-child(odd) > .tableCell {
    background-color: ${Theme.colors.ultraLightGrey};
  }

  .tableRow:nth-child(even) > .tableCell {
    background-color: ${Theme.colors.white};
  }

  .tableCell {
    vertical-align: top;
    background-color: #fafafa;
    width: 220px;
  }

  .tableValueHeader {
    padding: 8px 16px;
    text-align: left;
    vertical-align: top;
    display: flex;
    overflow: hidden;
  }

  .tableValue {
    display: table-cell;
    padding: 8px 16px;
    text-align: left;
    vertical-align: top;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
  }

  .sticky {
    position: sticky;
    left: 0;
  }

  img {
    vertical-align: middle;
  }
`
